require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-kate-fleming.json") })
        }
      }, "path---blog-author-kate-fleming");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-kate-fleming!./.cache/json/blog-author-kate-fleming.json
// module id = 663
// module chunks = 231608221292675